import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { getUserSession } from '../../../../core/util/core/Session';
import config from '../../../config/config';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const session = getUserSession();

    const pathFrontEnd = '/accountingclients/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}accountingclients/delete`,
        endpoint: config.endpoints.backend + 'accountingclients/getall',
        endpointGetAllClients: config.endpoints.backend + 'clients/getall'
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'document',
                type: 'text',
                label: 'Documento do Cliente',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'people_name',
                type: 'text',
                label: 'Nome do Cliente',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Clientes Contábeis',
        labelTitleButtonAdd: 'Incluir novo cliente',
        fieldsShowOnDelete: ['nompes'],
        showPrintButtons: true,
        formFilters: filters,
        canDelete: false,
        filter: {
            pdc_company_id: session.loggedUserInfo.pdc_company_id
        },
        columns: [
            {
                name: 'document',
                label: 'Documento',
                width: '30%'
            },
            {
                name: 'people_name',
                label: 'Nome do cliente',
                width: '30%'
            },
            {
                name: 'address',
                label: 'Endereço'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
